import {
  validateFieldForRequired,
  validateFieldForZipCode,
  validateFieldPhoneNumber
} from 'libs/validator';

export const ADDRESS_INFO_KEYS = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  ADDRESS: 'address',
  APARTMENT: 'extended_address',
  CITY: 'city',
  COUNTRY: 'user_country',
  REGION: 'region',
  ZIP_CODE: 'zip_code',
  PHONE_NUMBER: 'phone_number'
};

export const ERROR_INFO_KEYS = {
  BILLING_ADDRESS_FORM: 'billingAddressForm'
};

export const BILLING_ADDRESS_ERROR_CONFIG = {
  errorKeyBilling: ERROR_INFO_KEYS.BILLING_ADDRESS_FORM,
  errorFieldsBilling: [
    ADDRESS_INFO_KEYS.FIRST_NAME,
    ADDRESS_INFO_KEYS.LAST_NAME,
    ADDRESS_INFO_KEYS.ADDRESS,
    ADDRESS_INFO_KEYS.APARTMENT,
    ADDRESS_INFO_KEYS.CITY,
    ADDRESS_INFO_KEYS.COUNTRY,
    ADDRESS_INFO_KEYS.REGION,
    ADDRESS_INFO_KEYS.ZIP_CODE,
    ADDRESS_INFO_KEYS.PHONE_NUMBER
  ]
};

export const showCanadaProvinces = country => country.value === 'CA';

export const showUsStates = country => (country.value === 'US');

export const getRegionPlaceholderText = (country) => {
  let region = 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.region.placeholder.provinces';
  if (country && country.value === 'US') {
    region = 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.region.placeholder.states';
  }
  return region;
};

export const getZipCodePlaceholderText = (country) => {
  let zipCode = 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.zipCode.placeholder.postalCode';
  if (country && country.value === 'US') {
    zipCode = 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.zipCode.placeholder';
  }
  return zipCode;
};

export function checkErrors(errorFields = [], addressInfo = {}) {
  const errors = {};

  if (errorFields.indexOf(ADDRESS_INFO_KEYS.FIRST_NAME) !== -1) {
    const firstNameError = validateFieldForRequired(
      addressInfo[ADDRESS_INFO_KEYS.FIRST_NAME]
    );
    if (firstNameError) {
      errors[ADDRESS_INFO_KEYS.FIRST_NAME] = firstNameError;
    }
  }

  if (errorFields.indexOf(ADDRESS_INFO_KEYS.LAST_NAME) !== -1) {
    const lastNameError = validateFieldForRequired(
      addressInfo[ADDRESS_INFO_KEYS.LAST_NAME]
    );
    if (lastNameError) {
      errors[ADDRESS_INFO_KEYS.LAST_NAME] = lastNameError;
    }
  }

  if (errorFields.indexOf(ADDRESS_INFO_KEYS.ADDRESS) !== -1) {
    const addressError = validateFieldForRequired(
      addressInfo[ADDRESS_INFO_KEYS.ADDRESS]
    );
    if (addressError) {
      errors[ADDRESS_INFO_KEYS.ADDRESS] = addressError;
    }
  }

  if (errorFields.indexOf(ADDRESS_INFO_KEYS.PHONE_NUMBER) !== -1) {
    const phoneNumberError = validateFieldPhoneNumber(addressInfo[ADDRESS_INFO_KEYS.PHONE_NUMBER]);
    if (phoneNumberError) {
      errors[ADDRESS_INFO_KEYS.PHONE_NUMBER] = phoneNumberError;
    }
  }

  if (errorFields.indexOf(ADDRESS_INFO_KEYS.COUNTRY) !== -1) {
    const country = addressInfo[ADDRESS_INFO_KEYS.COUNTRY];
    const countryError = validateFieldForRequired(country.value);
    if (countryError) {
      errors[ADDRESS_INFO_KEYS.COUNTRY] = countryError;
    }
  }

  if (errorFields.indexOf(ADDRESS_INFO_KEYS.REGION) !== -1) {
    const country = addressInfo[ADDRESS_INFO_KEYS.COUNTRY];
    const isShowCanadaProvinces = showCanadaProvinces(country);
    const isShowUsStates = showUsStates(country);

    const regionError = (isShowCanadaProvinces || isShowUsStates)
      ? validateFieldForRequired(addressInfo[ADDRESS_INFO_KEYS.REGION].value)
      : '';

    if (regionError) {
      errors[ADDRESS_INFO_KEYS.REGION] = regionError;
    }
  }

  if (errorFields.indexOf(ADDRESS_INFO_KEYS.CITY) !== -1) {
    const cityError = validateFieldForRequired(
      addressInfo[ADDRESS_INFO_KEYS.CITY]
    );

    if (cityError) {
      errors[ADDRESS_INFO_KEYS.CITY] = cityError;
    }
  }

  if (errorFields.indexOf(ADDRESS_INFO_KEYS.ZIP_CODE) !== -1) {
    const country = addressInfo[ADDRESS_INFO_KEYS.COUNTRY];
    const isShowCanadaProvinces = showCanadaProvinces(country);
    const isShowUsStates = showUsStates(country);

    const country_code = addressInfo[ADDRESS_INFO_KEYS.COUNTRY].value;

    let zipCodeError = '';
    zipCodeError = (isShowCanadaProvinces || isShowUsStates)
      ? validateFieldForZipCode(addressInfo[ADDRESS_INFO_KEYS.ZIP_CODE], country_code)
      : '';

    if (zipCodeError) {
      errors[ADDRESS_INFO_KEYS.ZIP_CODE] = zipCodeError;
    }
  }
  return errors;
}

export default {
  ADDRESS_INFO_KEYS
};



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/AddressDetails/config.js